import { isApiKeyExpired } from "shared/ApiKey/helpers";
import { ApiKey } from "types/generated";

export type PersonalApiKeyIssue = "REVOKED" | "EXPIRED";

export const getPersonalApiKeyIssue = (
  apiKey: Pick<ApiKey, "disabled" | "expiresAt">
): PersonalApiKeyIssue | undefined => {
  if (apiKey.disabled) {
    return "REVOKED";
  }

  if (isApiKeyExpired(apiKey.expiresAt)) {
    return "EXPIRED";
  }

  return undefined;
};
